// extracted by mini-css-extract-plugin
export default {"card":"styles_card__t-fCs","active":"styles_active__7vIgs"};